export { Cpagelayout } from './Cpagelayout';
export type { CpagelayoutProps } from './Cpagelayout';

